module.exports = __webpack_public_path__ + "img/about1.cc64a50c.png";